import { ExpandMore as ExpandMoreIcon, ExpandLess } from '@mui/icons-material'
import { ReactElement, useState } from 'react'
import styled from 'styled-components'
import { VehicleEngines } from './VehicleEngines'
import { MakeFitment } from 'interfaces'
import { breakpoints } from '../../../theme/breakpoints'

interface VehicleFitmentProps {
  vehicle: MakeFitment
}

export const VehicleMakes = (props: VehicleFitmentProps): ReactElement => {
  const { vehicle } = props
  const [open, setOpen] = useState(false)
  return (
    <Wrapper>
      <Row>
        <MakeTd clickable onClick={() => setOpen(!open)}>
          {open && <ExpandLess style={iconStyle} />}
          {!open && <ExpandMoreIcon style={iconStyle} />}
          {vehicle?.make}
        </MakeTd>
        <YearsTd>{vehicle?.years}</YearsTd>
        <TotalTd>{vehicle?.totalApps}</TotalTd>
      </Row>
      {open &&
        vehicle?.engines.map((engine) => (
          <VehicleEngines key={engine?.engine} engine={engine} />
        ))}
    </Wrapper>
  )
}
const iconStyle = {
  marginRight: '6px',
  color: '#000',
  width: 20,
  height: 20,
  marginLeft: '0.5rem',
}

const Wrapper = styled.div`
  background: #f9f9f7;
  text-align: left;
`
const Row = styled.div`
  /* Light Gray */

  display: flex;
  justify-content: flex-start;
  align-items: center;
`
interface TdProps {
  clickable?: boolean
  width?: string
}
const Td = styled.div<TdProps>`
  vertical-align: top;
  padding: 16px 0px 16px 0px;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */

  /* Almost Black */

  color: #050505;

  mix-blend-mode: normal;
  border-bottom: 1px solid black;
  opacity: 0.9;
  text-decoration: 'none';
  cursor: ${(p) => (p.clickable ? 'pointer' : 'auto')};
  width: ${(p) => p.width};
  white-space: nowrap;
`
const MakeTd = styled(Td)`
  width: 40%;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 50%;
  }
`
const YearsTd = styled(Td)`
  width: 20%;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 20%;
  }
`
const TotalTd = styled(Td)`
  width: 40%;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 30%;
  }
`
